import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { constants } from '../helpers/constants';

const Portfolio = ({setActivePortfolio, deviceMobile}) => {

    
    const [divPortfolio, inViewPortfolio] = useInView({ threshold: 0.5});
    // const [refOne, inViewOne] = useInView({ threshold: deviceMobile ? 0.2 : 0.5, triggerOnce:true });
    
    const divRefOne = useRef(null);
    const divRefTwo = useRef(null);
    const divRefThree = useRef(null);
    const divRefFour = useRef(null);
    const divRefFive = useRef(null);
    const divRefSix = useRef(null);

    const [refOne, inViewOne] = useInView({ threshold: 0.5, triggerOnce:true });
    const [refTwo, inViewTwo] = useInView({ threshold: 0.5, triggerOnce:true });
    const [refThree, inViewThree] = useInView({ threshold: 0.5, triggerOnce:true });
    const [refFour, inViewFour] = useInView({ threshold: 0.5, triggerOnce:true });
    const [refFive, inViewFive] = useInView({ threshold: 0.5, triggerOnce:true });
    const [refSix, inViewSix] = useInView({ threshold: 0.5, triggerOnce:true });
  

    const clickImgPortoflio = (URL) => {
        const win = window.open(URL, '_blank');
        win.focus();
    }
    
    const domain = constants.domain
    const http = constants.http
    

    const linksPortfolio = {
        memoryGame: `${http}://memorygame.${domain}/`,
        youChat: `${http}://youchat.${domain}/`,
        appnomina: 'http://appnomina-react.s3-website-us-east-1.amazonaws.com/',
        appturnos:`${http}://appturnos.${domain}`,
        smsapp: `${http}://smsapp.${domain}/`,
        funguadalupe: 'https://funguadalupe-8dzy-eyveuyzi2-raffguts-projects.vercel.app/'
    }
    
    useEffect(() => {
        if (inViewPortfolio) {
          setActivePortfolio(true); // Activa el estado del navbar
        } else {
            setActivePortfolio(false); // Desactiva el estado cuando ya no está visible
        }
    }, [inViewPortfolio, setActivePortfolio]);

    

  return (
      <div ref={divPortfolio} id="portfolio">

        
            <div className=" container px-4 px-lg-5" style={{paddingTop: '100px'}}>
                <h2 className="text-center mt-0">Mis Proyectos</h2>
                {deviceMobile && <p className='text-muted text-center'>Toca un proyecto para más detalle.</p>}
                <hr className="divider" />
                <div className='row g-4'>

                <motion.div
                    ref={divRefOne}
                    className={`animate ${inViewOne ? 'show' : ''} col-12 col-md-6 col-lg-4 `}
                    initial={{ opacity: 0, y: -100 }}
                    animate={inViewOne ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 1 }}>
                    
                    <div ref={refOne} className='container-img-portfolio col'>
                        <figure>
                            <img  src='./assets/smsapp.jpg' alt='' title='sms app'/>
                            <div className='layer-text'>
                                <h3>SMS-APP</h3>
                                <p>Aplicación web para envío de sms marketing, control de contactos, grupos y links cortos.</p>
                                <button onClick={() => clickImgPortoflio(linksPortfolio.smsapp)}  className='btn btn-sm btn-primary btn-link-portfolio btn-rounded'>Ir a SMS-APP</button>
                            </div>
                        </figure>
                    </div>

                </motion.div>

                <motion.div
                    ref={divRefTwo}
                    className={`animate ${inViewTwo ? 'show' : ''} col-12 col-md-6 col-lg-4`}
                    initial={{ opacity: 0, y: -100 }}
                    animate={inViewTwo ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 1 }}>

                    <div ref={refTwo} className='container-img-portfolio col'>
                        <figure>
                            <img  src='./assets/funguadalupe.jpg' alt='' title='Funguadalupe...'/>
                            <div className='layer-text'>
                                <h3>Funguadalupe</h3>
                                <p style={{fontSize: '12px'}}>Página web de la Fundación Educativa Nuestra Señora de Guadalupe completamente responsive hecha en react js.</p>
                                <button onClick={() => clickImgPortoflio(linksPortfolio.funguadalupe)}  className='btn btn-sm btn-primary btn-link-portfolio btn-rounded'>Ir a Funguadalupe</button>
                            </div>
                        </figure>
                    </div>

                </motion.div>

                <motion.div
                    ref={divRefThree}
                    className={`animate ${inViewThree ? 'show' : ''} col-12 col-md-6 col-lg-4 `}
                    initial={{ opacity: 0, y: -100 }}
                    animate={inViewThree ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 1 }}>

                    <div ref={refThree} className='container-img-portfolio col'>
                        <figure>
                            <img  src='./assets/youchat.jpg' alt='' title='Chat en línea...'/>
                            <div className='layer-text'>
                                <h3>YouChat</h3>
                                <p>Chat en tiempo real para que te comuniques con tu grupo de amigos en las diferentes salas disponibles. </p>
                                <button onClick={() => clickImgPortoflio(linksPortfolio.youChat)}  className='btn btn-sm btn-primary btn-link-portfolio btn-rounded'>Ir a Youchat</button>
                            </div>
                        </figure>
                    </div>
                </motion.div>
                
                <motion.div
                    ref={divRefFour}
                    className={`animate ${inViewFour ? 'show' : ''} col-12 col-md-6 col-lg-4`}
                    initial={{ opacity: 0, y: -100 }}
                    animate={inViewFour ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 1 }}>

                    <div ref={refFour} className='container-img-portfolio col'>
                        <figure>
                            <img  src='./assets/appturnos.jpg' alt='' title='App turnos online...'/>
                            <div className='layer-text'>
                                <h3>App Turnos Online</h3>
                                <p>Demo de aplicación online para toma de turnos y atención en módulos, cuenta con panel de turnos para los clientes con mensajes de llamado a los módulosde atención. </p>
                                <button onClick={() => clickImgPortoflio(linksPortfolio.appturnos)}  className='btn btn-sm btn-primary btn-link-portfolio btn-rounded'>Ir a AppTurnos</button>
                            </div>
                        </figure>
                    </div>
                </motion.div>

                <motion.div
                    ref={divRefFive}
                    className={`animate ${inViewFive ? 'show' : ''} col-12 col-md-6 col-lg-4`}
                    initial={{ opacity: 0, y: -100 }}
                    animate={inViewFive ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 1 }}>

                    <div ref={refFive} className='container-img-portfolio col'>
                        <figure>
                            <img  src='./assets/memorygame.jpg' alt='' title='Juego de memoria...'/>
                            <div className='layer-text'>
                                <h3>MemoryGame</h3>
                                <p>Usa tu memoria para ubicar las imágenes idénticas en el menor tiempo y con el menor número de intentos. </p>
                                <button onClick={() => clickImgPortoflio(linksPortfolio.memoryGame)}  className='btn btn-sm btn-primary btn-link-portfolio btn-rounded'>Ir a Memorygame</button>
                            </div>
                        </figure>
                    </div>
                </motion.div>

                <motion.div
                    ref={divRefSix}
                    className={`animate ${inViewSix ? 'show' : ''} col-12 col-md-6 col-lg-4`}
                    initial={{ opacity: 0, y: -100 }}
                    animate={inViewSix ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 1 }}>

                    <div ref={refSix} className='container-img-portfolio col'>
                        <figure>
                            <img  src='./assets/appnomina.jpg' alt='' title='App Nómina...'/>
                            <div className='layer-text'>
                                <h3>App Nómina</h3>
                                <p style={{fontSize: '12px'}}>Aplicación con algunos procesos de control de nómina como registro de empleados, administradores de nómina, descarga de certificados y volantes de pago en formato pdf. Fue desarrollada con fines educativos y desplegada en AWS.</p>
                                <button onClick={() => clickImgPortoflio(linksPortfolio.appnomina)}  className='btn btn-sm btn-primary btn-link-portfolio btn-rounded'>Ir a AppNomina</button>
                            </div>
                        </figure>
                    </div>
                </motion.div>


                </div>
            
            </div>
        
          
      </div>

  )
}

export default Portfolio